import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { RouteLocationNormalized } from 'vue-router';
import { useUserStore } from './stores/user.ts';
import App from './App.vue';
import './index.css';
import { createVuetify, directives, components } from './plugins/vuetify/vuetify.js';
import '@mdi/font/css/materialdesignicons.css';
import router from './router';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

router.beforeEach(async (to, from) => {
    const userStore = useUserStore();
    await userStore.isLoggedIn;

    if (to.path === '/') {
        if (userStore.accessToken) return '/dashboard';
        else return '/auth/login';
    }
    const canAccess = await canUserAccess(to);
    if (!canAccess) return '/auth/login';
});

const vuetify = createVuetify({
    components,
    directives,
    locale: {
        locale: 'pl',
    },
    date: {
        locale: {
            pl: 'pl-PL',
        },
    },
});

const pinia = createPinia();
createApp(App)
    .use(router)
    .use(pinia)
    .use(vuetify)
    .component('VueDatePicker', VueDatePicker)
    .mount('#app');

async function canUserAccess(route: RouteLocationNormalized) {
    const authedRoutes = [
        '/dashboard',
        '/files',
    ];

    if (authedRoutes.includes(route.path)) {
        const userStore = useUserStore();
        return await userStore.isLoggedIn;
    }
    return true;
}